// assets/ss-sample-limit.js
(function () {
  if (window.SS_SAMPLE_LIMIT && window.SS_SAMPLE_LIMIT.canAdd) return;

  // Debug ALWAYS ON
  const DEBUG = true;

  function dbg() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, ["[SS_SAMPLE_LIMIT]"].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function mildNotify(message) {
    dbg("mildNotify called", { message });

    if (window.SS_NOTIFY && window.SS_NOTIFY.show) {
      window.SS_NOTIFY.show(message, "error"); // sample-limit violations are "error"
      return;
    }

    // Fallback
    alert(message);
  }

  async function getCart() {
    dbg("getCart -> /cart.js");
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    dbg("getCart response", { ok: res.ok, status: res.status });
    if (!res.ok) throw new Error("Failed to read cart");
    const cart = await res.json();
    dbg("getCart cart", {
      item_count: cart && cart.item_count,
      items_len: cart && cart.items && cart.items.length,
    });
    return cart;
  }

  function countSamplesForHandle(cart, handle) {
    if (!cart || !Array.isArray(cart.items) || !handle) {
      dbg("countSamplesForHandle early return", { hasCart: !!cart, handle });
      return 0;
    }

    const total = cart.items.reduce((sum, item) => {
      const props = item && item.properties ? item.properties : {};
      const itemHandle = props && props._sample_for_handle ? String(props._sample_for_handle) : "";
      if (itemHandle === String(handle)) {
        const q = typeof item.quantity === "number" ? item.quantity : 0;
        return sum + q;
      }
      return sum;
    }, 0);

    dbg("countSamplesForHandle", { handle, total });
    return total;
  }

  /**
   * Checks if we can add `addQty` samples for `sampleForHandle`
   * Enforces maxPerHandle (default 2).
   */
  async function canAdd(sampleForHandle, addQty, maxPerHandle) {
    const qtyToAdd = typeof addQty === "number" ? addQty : 1;
    const limit = typeof maxPerHandle === "number" ? maxPerHandle : 2;

    dbg("canAdd called", { sampleForHandle, qtyToAdd, limit });

    if (!sampleForHandle) {
      // If handle missing, don't block add (but you probably want to fix data attrs)
      dbg("canAdd: missing handle -> allow");
      return { ok: true, current: 0, limit };
    }

    const cart = await getCart();
    const current = countSamplesForHandle(cart, sampleForHandle);
    const ok = current + qtyToAdd <= limit;

    dbg("canAdd result", { ok, current, qtyToAdd, limit });

    return { ok, current, limit, cart };
  }

  /**
   * Convenience: checks + shows mild notification if blocked.
   */
  async function enforceOrNotify(sampleForHandle, addQty, maxPerHandle) {
    dbg("enforceOrNotify called", { sampleForHandle, addQty, maxPerHandle });

    const result = await canAdd(sampleForHandle, addQty, maxPerHandle);

    dbg("enforceOrNotify result", result);

    if (!result.ok) {
      dbg("BLOCKED -> notifying");
      mildNotify(`You can order at most ${result.limit} samples of the same product.`);
    } else {
      dbg("ALLOWED -> no notify");
    }

    return result;
  }

  window.SS_SAMPLE_LIMIT = {
    canAdd,
    enforceOrNotify,
    mildNotify,
  };

  dbg("SS_SAMPLE_LIMIT ready");
})();
